import React from 'react';
import MetaTags from './components/MetaTags';
import AppBar from './components/AppBar';
import Footer from './components/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  FaWhatsapp, 
  FaPhone, 
  FaLocationDot, 
  FaEnvelope, 
  FaTruckFast, 
  FaShieldHalved, 
  FaStar, 
  FaRoute 
} from "react-icons/fa6";

const ContactUs = () => {
  const primaryNumber = "8754179585";
  const primaryDisplay = "+91 87541 79585";
  const secondaryNumber = "7810049585";
  const secondaryDisplay = "+91 78100 49585";
  const emailAddress = "sugunacrackers@gmail.com";
  const mapUrl = "https://maps.app.goo.gl/qir821PWSGWdPsTA6";
  const mapEmbedSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1391.7616394715787!2d77.91035174989369!3d9.377756267835332!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cb0b1644a621%3A0xc765568d0a10d200!2sSuguna%20crackers!5e0!3m2!1sen!2sin!4v1725305448221!5m2!1sen!2sin";

  return (
    <div>
      <MetaTags
        title="Contact Us - Suguna Crackers | Wholesale & Retail Sivakasi Crackers"
        type="website"
        siteName="sugunacrackers.com"
        url="https://sugunacrackers.com/contact"
        keywords="Contact Us, Suguna Crackers, Sivakasi Crackers Wholesale, Diwali Crackers Contact, Buy Crackers Sattur"
        description="Contact Suguna Crackers for wholesale and retail firecrackers. Call +91 87541 79585 or WhatsApp for Diwali orders and instant quotation."
        revisitAfter="10 Days"
      />
      <AppBar />
      
      {/* Top Banner */}
      <div className='w-100'>
        <img 
          src={require('../assets/images/banner_three.jpg')} 
          className='img-fluid w-100' 
          alt='Suguna Crackers Contact Banner' 
        />
      </div>

      {/* Main Content Area */}
      <div className='contact-page-wrapper py-5'>
        <Container>
          {/* Section Header */}
          <Row className='justify-content-center text-center mb-5'>
            <Col lg={8} md={10} xs={12}>
              <span className='contact-header-badge'>
                <FaStar className='me-1' /> Get In Touch
              </span>
              <h1 className='contact-main-title'>Contact Suguna Crackers</h1>
              <p className='contact-subtitle'>
                Have questions about pricing, bulk orders, or festival discounts? 
                Reach out to us directly via Call or WhatsApp for immediate assistance!
              </p>
            </Col>
          </Row>

          {/* Cards & Map Grid */}
          <Row className='g-4 align-items-stretch'>
            {/* Left Column: Contact Cards */}
            <Col lg={6} md={12} xs={12}>
              <Row className='g-4'>
                {/* First Phone Card (Call + WhatsApp) */}
                <Col xs={12}>
                  <div className='contact-card primary-highlight'>
                    <div>
                      <div className='d-flex justify-content-between align-items-center mb-2'>
                        <span className='badge bg-success text-white px-3 py-1 rounded-pill' style={{ fontSize: '11px', fontWeight: 'bold' }}>
                          <FaWhatsapp className='me-1' /> Call & WhatsApp
                        </span>
                        <span className='badge bg-success-subtle text-success border border-success-subtle px-2 py-1' style={{ fontSize: '11px', fontWeight: 'bold' }}>
                          Fast Response
                        </span>
                      </div>

                      <div className='contact-card-top'>
                        <div className='contact-icon-box icon-box-green'>
                          <FaPhone size={22} />
                        </div>
                        <div>
                          <div className='contact-card-title'>Call & WhatsApp Hotline</div>
                          <a href={`tel:+91${primaryNumber}`} className='contact-phone-display text-success'>
                            {primaryDisplay}
                          </a>
                        </div>
                      </div>

                      <p className='contact-card-desc'>
                        Direct contact hotline for quick phone orders, price quotations, and instant WhatsApp support. Available throughout the festive season.
                      </p>
                    </div>

                    <div className='contact-action-group'>
                      <a href={`tel:+91${primaryNumber}`} className='contact-btn contact-btn-call'>
                        <FaPhone size={14} /> Call Now
                      </a>
                      <a 
                        href={`https://wa.me/91${primaryNumber}?text=Hello%20Suguna%20Crackers%2C%20I%20want%20to%20enquire%20about%20firecrackers%20price%20list`} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='contact-btn contact-btn-whatsapp'
                      >
                        <FaWhatsapp size={16} /> WhatsApp Chat
                      </a>
                    </div>
                  </div>
                </Col>

                {/* Second Phone Card */}
                <Col xs={12}>
                  <div className='contact-card'>
                    <div>
                      <div className='d-flex justify-content-between align-items-center mb-2'>
                        <span className='badge bg-light text-dark border px-3 py-1 rounded-pill' style={{ fontSize: '11px', fontWeight: 'bold' }}>
                          <FaPhone className='me-1' /> Customer Care
                        </span>
                        <span className='badge bg-light text-secondary border px-2 py-1' style={{ fontSize: '11px' }}>
                          Available Everyday
                        </span>
                      </div>

                      <div className='contact-card-top'>
                        <div className='contact-icon-box icon-box-blue'>
                          <FaPhone size={20} />
                        </div>
                        <div>
                          <div className='contact-card-title'>Enquiries & Booking Support</div>
                          <a href={`tel:+91${secondaryNumber}`} className='contact-phone-display'>
                            {secondaryDisplay}
                          </a>
                        </div>
                      </div>

                      <p className='contact-card-desc'>
                        Customer line for order tracking, transport booking details, parcel guidance, and festival enquiries.
                      </p>
                    </div>

                    <div className='contact-action-group'>
                      <a href={`tel:+91${secondaryNumber}`} className='contact-btn contact-btn-call'>
                        <FaPhone size={14} /> Call Now
                      </a>
                      <a 
                        href={`https://wa.me/91${secondaryNumber}?text=Hello%20Suguna%20Crackers`} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='contact-btn contact-btn-outline'
                      >
                        <FaWhatsapp size={16} color="#25D366" /> WhatsApp
                      </a>
                    </div>
                  </div>
                </Col>

                {/* Location Card */}
                <Col sm={6} xs={12}>
                  <div className='contact-card'>
                    <div>
                      <span className='contact-badge-pill badge-location'>
                        Store & Godown
                      </span>

                      <div className='contact-card-top'>
                        <div className='contact-icon-box icon-box-yellow'>
                          <FaLocationDot size={20} />
                        </div>
                        <div>
                          <div className='contact-card-title'>Store Location</div>
                        </div>
                      </div>

                      <p className='contact-card-desc mb-2'>
                        <strong>Byepass Road, Venkatachalapuram,</strong><br />
                        Sattur - 626203, Tamil Nadu
                      </p>
                    </div>

                    <div className='contact-action-group mt-3'>
                      <a 
                        href={mapUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className='contact-btn contact-btn-outline w-100'
                      >
                        <FaRoute size={14} /> Directions
                      </a>
                    </div>
                  </div>
                </Col>

                {/* Email Card */}
                <Col sm={6} xs={12}>
                  <div className='contact-card'>
                    <div>
                      <span className='contact-badge-pill badge-email'>
                        Email Enquiries
                      </span>

                      <div className='contact-card-top'>
                        <div className='contact-icon-box icon-box-red'>
                          <FaEnvelope size={20} />
                        </div>
                        <div>
                          <div className='contact-card-title'>Email Us</div>
                        </div>
                      </div>

                      <p className='contact-card-desc mb-2'>
                        <span className='text-break fw-semibold'>{emailAddress}</span><br />
                        Send quotation requests anytime.
                      </p>
                    </div>

                    <div className='contact-action-group mt-3'>
                      <a 
                        href={`mailto:${emailAddress}`} 
                        className='contact-btn contact-btn-outline w-100'
                      >
                        <FaEnvelope size={14} /> Send Mail
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Right Column: Google Maps Embed */}
            <Col lg={6} md={12} xs={12}>
              <div className='contact-map-container'>
                <div className='contact-map-header'>
                  <div>
                    <h5 className='contact-card-title mb-1'>Find Us On Google Maps</h5>
                    <small className='text-muted'>
                      <FaLocationDot className='text-danger me-1' /> Venkatachalapuram, Sattur - Sivakasi Region
                    </small>
                  </div>
                  <span className='badge bg-success-subtle text-success border border-success-subtle px-3 py-2'>
                    ● Open for Diwali Orders
                  </span>
                </div>

                <iframe
                  src={mapEmbedSrc}
                  className='contact-map-iframe'
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps Embed of Suguna Crackers, Sattur"
                />

                <div className='contact-map-footer'>
                  <span className='regular text-muted' style={{ fontSize: '13px' }}>
                    Easily accessible on Sattur Byepass Road with direct parking.
                  </span>
                  <a 
                    href={mapUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className='contact-btn contact-btn-call py-2 px-3'
                    style={{ fontSize: '13px', flex: 'none' }}
                  >
                    <FaRoute size={13} /> Open in Google Maps
                  </a>
                </div>
              </div>
            </Col>
          </Row>

          {/* Trust Highlights Strip */}
          <div className='contact-trust-strip'>
            <Row className='g-3'>
              <Col lg={3} sm={6} xs={12}>
                <div className='contact-trust-item'>
                  <div className='contact-trust-icon text-success'>
                    <FaStar />
                  </div>
                  <div>
                    <div className='contact-trust-title'>Direct Factory Rates</div>
                    <p className='contact-trust-sub'>100% Sivakasi pricing without middlemen</p>
                  </div>
                </div>
              </Col>

              <Col lg={3} sm={6} xs={12}>
                <div className='contact-trust-item'>
                  <div className='contact-trust-icon text-primary'>
                    <FaTruckFast />
                  </div>
                  <div>
                    <div className='contact-trust-title'>Safe Transport Delivery</div>
                    <p className='contact-trust-sub'>Dispatched via registered transport operators</p>
                  </div>
                </div>
              </Col>

              <Col lg={3} sm={6} xs={12}>
                <div className='contact-trust-item'>
                  <div className='contact-trust-icon text-success'>
                    <FaWhatsapp />
                  </div>
                  <div>
                    <div className='contact-trust-title'>Quick WhatsApp Support</div>
                    <p className='contact-trust-sub'>Get estimated order confirmations quickly</p>
                  </div>
                </div>
              </Col>

              <Col lg={3} sm={6} xs={12}>
                <div className='contact-trust-item'>
                  <div className='contact-trust-icon text-danger'>
                    <FaShieldHalved />
                  </div>
                  <div>
                    <div className='contact-trust-title'>100% Legal & Compliant</div>
                    <p className='contact-trust-sub'>Licensed godowns following explosive acts</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {/* Quick Festive CTA Banner */}
          <div className='contact-cta-banner'>
            <Row className='align-items-center g-3'>
              <Col lg={8} md={7} xs={12}>
                <h3 className='bold mb-2'>Looking for Diwali Crackers Wholesale or Retail?</h3>
                <p className='regular mb-0' style={{ fontSize: '16px' }}>
                  Send your enquiry now on WhatsApp or call us directly at <strong>+91 {primaryNumber}</strong> for the best festive combos & gift box discounts!
                </p>
              </Col>
              <Col lg={4} md={5} xs={12} className='text-lg-end text-center'>
                <div className='d-flex flex-wrap gap-2 justify-content-lg-end justify-content-center'>
                  <a 
                    href={`https://wa.me/91${primaryNumber}?text=Hello%20Suguna%20Crackers%2C%20I%20am%20looking%20for%20Diwali%20crackers%20wholesale%20deal`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className='contact-btn contact-btn-whatsapp'
                  >
                    <FaWhatsapp size={16} /> WhatsApp Us
                  </a>
                  <a 
                    href={`tel:+91${primaryNumber}`} 
                    className='contact-btn contact-btn-call'
                  >
                    <FaPhone size={14} /> Call Now
                  </a>
                </div>
              </Col>
            </Row>
          </div>

        </Container>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;